import { render, staticRenderFns } from "./InfoCupo.vue?vue&type=template&id=5fbd43c6"
import script from "./InfoCupo.vue?vue&type=script&lang=js"
export * from "./InfoCupo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports